import React, { Component } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { H1 } from '@mous221/hk-utils';
import { patientScansActions } from 'redux/actions';
import {
  // SearchForm,
  ResultTable,
} from './';
import { connect } from 'react-redux';

const ReportsWrapper = styled.div``;
const ReportsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  h1 {
    line-height: 60px;
    vertical-align: middle;
    margin-right: 20px;
  }
  form {
    display: flex;
    & > div {
      margin-bottom: 10px;
      margin-right: 30px;
      input {
        width: 350px;
        height: 50px;
      }
    }
    button {
      max-height: 48px;
    }
  }
`;
class Reports extends Component {
  componentDidMount() {
    const { getScans } = this.props;
    getScans();
  }
  state = {
    searchDate: null,
    name: null,
  };
  setPage = (page) => {
    const { getScans } = this.props;

    getScans(page);
  };
  setSearchDate = (date) => this.setState({ searchDate: date });
  setName = (name) => this.setState({ name });
  handleSearch = (page = null) => this.props.getScans(page);

  render() {
    const { scans, loading } = this.props;

    return (
      <ReportsWrapper>
        <ReportsHeader>
          <H1>Reports</H1>
          {/* <SearchForm
            handleSearch={this.handleSearch}
            setSearchDate={this.setSearchDate}
            setName={this.setName}
          /> */}
        </ReportsHeader>
        {scans && (
          <ResultTable
            loading={loading}
            finishedRequests={scans}
            setPage={this.setPage}
          />
        )}
      </ReportsWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  const { loading, scans } = state.scans;

  return {
    scans,
    loading,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getScans: (page = null) => dispatch(patientScansActions.getScans(page)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Reports);

Reports.propTypes = {
  scans: PropTypes.object,
  getScans: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};
